(function ($) {
    $(document).ready(function () {
        var zIndex = 0;
        var countItem = 0;
        var solved = [];

        $(".gridcontainer .ce_image:not(.main)").each(function (index) {

            $thisDraggable = $(this).find('img');
            $thisDraggable.data("map", index);
            $thisDraggable.draggable({
                addClasses: false,
                containment: ".js-dragregion",
                opacity: 0.85,
                start: function (event, ui) {
                    zIndex++;
                    $(this).removeClass('greenlight');
                    $(this).css("z-index", zIndex);
                },
                drag: function (event, ui) {
                }
            });

            countItem++;
        });

        $(".targetcontainer .content-text").each(function (index) {
            $(this).prepend($('<div class="map map' + index + '">'));
        });

        $('.gridcontainer .col-inside').randomizeChildrenOrder();

        $('.map').droppable({
            over: function (event, ui) {
            },
            drop: function (event, ui) {
                var draggableId = ui.draggable.data('map');

                if ($(this).hasClass('map' + draggableId)) {
                    ui.draggable.addClass('greenlight');

                    ui.draggable.draggable("option", "revert", false);

                    var dropped = ui.draggable;
                    var droppedOn = $(this);
                    $(dropped).detach().css({ top: 0, left: 0 }).appendTo(droppedOn);

                    //keep track of solved and then disable draggable
                    if (!solved.includes(draggableId)) {
                        solved.push(draggableId);
                        ui.draggable.draggable("disable");
                        ui.draggable.attr('draggable', false);
                    }

                    if (countItem == solved.length) {
                        showWhenSolved();
                    }

                } else {
                    ui.draggable.removeClass('greenlight');
                    ui.draggable.draggable("option", "revert", true);
                }

            }
        });


        function showWhenSolved() {
            $(".showWhenSolved").show();
            $("html, body").animate({
                scrollTop: ($(".showWhenSolved").offset().top - 250)
            }, 500);
        };
    });


    $.fn.randomizeChildrenOrder = function () {
        this.each(function () {
            let childrenArray = $(this).children().toArray();
            let shuffledChildrenArray = fisherYatesShuffle(childrenArray);
            $(shuffledChildrenArray).detach().appendTo(this);
        });

        return this;

        // https://stackoverflow.com/a/2450976/665825
        function fisherYatesShuffle(array) {
            let currentIndex = array.length, temporaryValue, randomIndex;
            while (currentIndex !== 0) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }
    }
})(jQuery);
